import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { initLenis, destroyLenis } from "./lib/scroll";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Profile } from "./components/Profile";
import { Stats } from "./components/Stats";
import { Analysis } from "./components/Analysis";
import { Videos } from "./components/Videos";
import { Gallery } from "./components/Gallery";
import { Market } from "./components/Market";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const Site = () => {
  const { lang } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="min-h-screen bg-ink-950 font-sans text-zinc-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Profile />
        <Stats />
        <Analysis />
        <Videos />
        <Gallery />
        <Market />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
